import request from '../utils/request'

/**
 * 分页查询操作日志（POST方式）
 */
export function getOperationLogPage(data) {
  return request({
    url: '/admin/operation-log/page',
    method: 'post',
    data
  })
}

/**
 * 分页查询操作日志（GET方式）
 */
export function getOperationLogPageByGet(params) {
  return request({
    url: '/admin/operation-log/page',
    method: 'get',
    params
  })
}

/**
 * 根据ID获取日志详情
 */
export function getOperationLogById(id) {
  return request({
    url: `/admin/operation-log/${id}`,
    method: 'get'
  })
}

/**
 * 根据追踪ID查询日志列表
 */
export function getOperationLogsByTraceId(traceId) {
  return request({
    url: `/admin/operation-log/trace/${traceId}`,
    method: 'get'
  })
}

/**
 * 获取操作类型列表
 */
export function getOperationTypes() {
  return request({
    url: '/admin/operation-log/operation-types',
    method: 'get'
  })
}

/**
 * 获取平台类型列表
 */
export function getPlatformTypes() {
  return request({
    url: '/admin/operation-log/platform-types',
    method: 'get'
  })
}

/**
 * 获取用户类型列表
 */
export function getUserTypes() {
  return request({
    url: '/admin/operation-log/user-types',
    method: 'get'
  })
}

/**
 * 获取操作状态列表
 */
export function getStatusList() {
  return request({
    url: '/admin/operation-log/status-list',
    method: 'get'
  })
}

